// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-img {
    position: relative;
    margin: 3px;
    background-color: #f3f4f6;
    border-radius: var(--radius-small);
    transition: transform 0.2s ease-in-out;
    box-shadow: var(--elevation-2);
    overflow: hidden;
}

.container-img:hover {
    box-shadow: var(--elevation-1);
    transform: scale(1.03);
    transition: transform 0.2s ease-in-out;
    cursor: pointer;
}

.container-img img,
.container-img video,
.container-img iframe {
    top: 0;
    width: 100%;
    border-radius: var(--radius-small);
    vertical-align: bottom;
    cursor: pointer;
}

.container-img .img-title-description {
    display: none;
    flex-direction: column;
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.85) 25%,
        rgba(255, 255, 255, 0) 100%
    );
    overflow: hidden;
    width: 100%;
    border-radius: 0px 0px var(--radius-small) var(--radius-small);
    max-height: 50%;
}

.container-img .img-title-description > h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.container-img .img-title-description > p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

.container-img .img-title-description > * {
    color: var(--on-primary-container);
    margin: 3px;
}

.img-icons-report-number-photos {
    display: flex !important;
    height: 25px;
}

.img-icons-report-number-photos > * {
    height: 100%;
    text-align: center;
    background-color: transparent !important;
}

.img-icons-report-number-photos > span {
    max-height: 16px;
    padding: 4px !important;
}

.img-icons-report-number-photos > md-icon {
    font-size: 24px !important;
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/common-card.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kCAAkC;IAClC,sCAAsC;IACtC,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;;;IAGI,MAAM;IACN,WAAW;IACX,kCAAkC;IAClC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT;;;;KAIC;IACD,gBAAgB;IAChB,WAAW;IACX,8DAA8D;IAC9D,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB,EAAE,4BAA4B;IACnD,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".container-img {\n    position: relative;\n    margin: 3px;\n    background-color: #f3f4f6;\n    border-radius: var(--radius-small);\n    transition: transform 0.2s ease-in-out;\n    box-shadow: var(--elevation-2);\n    overflow: hidden;\n}\n\n.container-img:hover {\n    box-shadow: var(--elevation-1);\n    transform: scale(1.03);\n    transition: transform 0.2s ease-in-out;\n    cursor: pointer;\n}\n\n.container-img img,\n.container-img video,\n.container-img iframe {\n    top: 0;\n    width: 100%;\n    border-radius: var(--radius-small);\n    vertical-align: bottom;\n    cursor: pointer;\n}\n\n.container-img .img-title-description {\n    display: none;\n    flex-direction: column;\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    background: linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0.85) 25%,\n        rgba(255, 255, 255, 0) 100%\n    );\n    overflow: hidden;\n    width: 100%;\n    border-radius: 0px 0px var(--radius-small) var(--radius-small);\n    max-height: 50%;\n}\n\n.container-img .img-title-description > h3 {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.container-img .img-title-description > p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2; /* number of lines to show */\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n\n.container-img .img-title-description > * {\n    color: var(--on-primary-container);\n    margin: 3px;\n}\n\n.img-icons-report-number-photos {\n    display: flex !important;\n    height: 25px;\n}\n\n.img-icons-report-number-photos > * {\n    height: 100%;\n    text-align: center;\n    background-color: transparent !important;\n}\n\n.img-icons-report-number-photos > span {\n    max-height: 16px;\n    padding: 4px !important;\n}\n\n.img-icons-report-number-photos > md-icon {\n    font-size: 24px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
